import axios from './axios';

export default {
  create: (local_it_id) => axios.post(`/local_its/${local_it_id}/travauxes`),
  update: (id, payload) => axios.put(`/travauxes/${id}`, { travaux: payload }),
  delete: (id) => axios.delete(`/travauxes/${id}`),
};